import { fileUploadColumn, grandTotalFields, totalsColumn, unitInputColumn, valueInputColumn } from './columns'

//  --- Diesel and Petrol Columns ---
// These columns are used for both Diesel and Petrol categories
// They require access to asset data to populate the asset field for selection
export const dieselAndPetrolColumns = (assetData) => [
    {
        label: 'Asset',
        field: 'asset',
        type: 'select',
        options:
            assetData && assetData.length > 0
                ?
                assetData?.map((asset) => {
                    return { id: asset._id, value: asset.asset }
                }) :
                [{ id: 0, value: 'No Assets' }],
        selectLabel: 'Select Asset'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Litres' },
            { id: 1, value: 'Rands' }
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

//  --- Diesel and Petrol Totals ---

export const dieselAndPetrolTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Litre Value', field: 'litresQuantity' },
    { label: 'Rand to Litre Conversion', field: 'randQuantity' },
    { label: 'Total Litres', field: 'total' }
]
export const dieselAndPetrolGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    // these values only exist to apply the N/A total in TotalTable.js
    { label: 'Litre Value', field: 'month' },
    { label: 'Rand to Litre Conversion', field: 'month' },
    { label: 'Grand Total Value', field: 'grand_total' },
]

// --- LPG Columns ---

export const lpgColumns = [
    {
        label: 'Type',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'LPG' }
        ],
        selectLabel: 'Select Type'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
            { id: 1, value: 'Rands' }
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

export const lpgTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Kilogram Value', field: 'kilogramsQuantity' },
    { label: 'Rand to Kilogram Conversion', field: 'randQuantity' },
    { label: 'Total Kilograms', field: 'total' }
]
export const lpgGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Kilogram Value', field: 'month' },
    { label: 'Rand to Kilogram Conversion', field: 'month' },
    { label: 'Grand Total Value', field: 'grand_total' },
]

// --- Refrigerant Gas Columns ---

export const refrigerantGasColumns = [
    {
        label: 'Type',
        field: 'asset',
        type: 'select',
        options: [
            { id: 1, value: 'Methane' },
            { id: 2, value: 'Nitrous oxide' },
            { id: 3, value: 'HFC-23' },
            { id: 4, value: 'HFC-32' },
            { id: 5, value: 'HFC-41' },
            { id: 6, value: 'HFC-125' },
            { id: 7, value: 'HFC-134' },
            { id: 8, value: 'HFC-134a' },
            { id: 9, value: 'HFC-143' },
            { id: 10, value: 'HFC-143a' },
            { id: 11, value: 'HFC-152a' },
            { id: 12, value: 'HFC-227ea' },
            { id: 13, value: 'HFC-236fa' },
            { id: 14, value: 'HFC-245fa' },
            { id: 15, value: 'HFC-43-10mee' },
            { id: 16, value: 'Perfluoromethane (PFC-14)' },
            { id: 17, value: 'Perfluoroethane (PFC-116)' },
            { id: 18, value: 'Perfluoropropane (PFC-218)' },
            { id: 19, value: 'Perfluorocyclobutane (PFC-318)' },
            { id: 20, value: 'Perfluorobutane (PFC-3-1-10)' },
            { id: 21, value: 'Perfluoropentane (PFC-4-1-12)' },
            { id: 22, value: 'Perfluorohexane (PFC-5-1-14)' },
            { id: 23, value: 'PFC-9-1-18' },
            { id: 24, value: 'Perfluorocyclopropane' },
            { id: 25, value: 'Sulphur hexafluoride (SF6)' },
            { id: 26, value: 'HFC-161' },
            { id: 27, value: 'HFC-236cb' },
            { id: 28, value: 'HFC-236ea' },
            { id: 29, value: 'R404A' },
            { id: 30, value: 'R507A' },
            { id: 31, value: 'HCFC-22/R22' },
            { id: 32, value: 'HFC-245ca' },
            { id: 33, value: 'HFC-365mfc' },
            { id: 34, value: 'R410A' },
            { id: 35, value: 'Nitrogen trifluoride' }
        ],
        selectLabel: 'Select Type'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

// --- Refrigerant Gas Totals ---

export const refrigerantGasTotalColumns = totalsColumn.kilograms
export const refrigerantGasGrandTotalFields = grandTotalFields.kilograms

// --- Dry Ice Columns ---

export const dryIceColumns = [
    {
        label: 'Type',
        field: 'asset',
        type: 'select',
        options: [
            { id: 0, value: 'Dry Ice' }
        ],
        selectLabel: 'Select Type'
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilograms' },
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

// -- Dry Ice Totals ---

export const dryIceTotalColumns = totalsColumn.kilograms
export const dryIceGrandTotalFields = grandTotalFields.kilograms